import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { useAppContext } from "../../../context/AppContext";
import Swal from "sweetalert2";
import Sidebar from "../../../components/Sidebar";
import SectionLoader from "../../../components/SectionLoader";
import BackButton from '../../../components/BackButton';
import { getOrCreateDeviceId } from "../../../utils/deviceId";
import { fixImageOrientation } from "../../../utils/fixImageOrientation";


const CompleteDelivery: React.FC = () => {
  const deliveryID = localStorage.getItem("delivery_id");
  const vendor_id = localStorage.getItem("vendor_id");
  const sales_order_id = localStorage.getItem('sales_order_id') || '';
  const zoho_sales_order_id = localStorage.getItem('zoho_sales_order_id') || '';
  const api_token = localStorage.getItem("_token");
  const navigate = useNavigate();
  const { 
    purchaseOrder, 
    delivery,
    setDelivery, 
    photos, 
    setPhotos,
    setPurchaseOrder,
    setToken,
    setSalesOrder,
    loads,
    setLoads,
    setAttachments,
    setLoadItems,
    setMeterialSo,
    setMaterialfo,
    setProgressDeliveries,
  } = useAppContext();
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [remainingLoads, setRemainingLoads] = useState<number>(0);
  const [deliveryCompleted, setDeliveryCompleted] = useState<boolean>(false);

  // Sync remaining loads from context
  useEffect(() => {
    if (loads) {
      const totalLoads = loads.total_loads || 0;
      const completedLoads = loads.completed_loads || 0;
      const remaining = Math.max(0, totalLoads - completedLoads);
      setRemainingLoads(remaining);
    }
  }, [loads]);

  // Fresh data fetch on load
  useEffect(() => {
    const fetchFreshData = async () => {
      if (!api_token || !sales_order_id) {
        setIsLoading(false);
        return;
      }

      if (delivery && delivery.id && delivery.status) {
        // Check if delivery is already completed
        if (delivery.status === 'completed') {
          // Already completed, can stay on page
          setIsLoading(false);
          return;
        }
        // Validate delivery status - should be 'reached' or 'delivered' for completion
        if (delivery.status !== 'reached' && delivery.status !== 'delivered') {
          if (delivery.status === 'picked_up') {
            navigate('/upload-weight-ticket');
          } else if (delivery.status === 'assigned') {
            navigate('/pick-up');
          } else if (delivery.status === 'open') {
            navigate('/');
          }
          setIsLoading(false);
          return;
        }
        setIsLoading(false);
        return;
      }

      if (vendor_id && sales_order_id) {
        try {
          const deviceId = getOrCreateDeviceId();
          const responseData = await ApiService.getFreshData({
            vendor_id: vendor_id,
            sales_order_id: sales_order_id,
            delivery_id: deliveryID || null,
            token: false,
            device_id: deviceId,
          });

          if (responseData && responseData.success) {
            setPurchaseOrder(responseData.data.purchase_order);
            setToken(responseData.api_token);
            setDelivery(responseData.data.delivery);
            setLoads(responseData.data.loads);
            setLoadItems(responseData.data.item_loads);
            setPhotos(responseData.data.photos || []);
            setAttachments(responseData.data.attachments || []);
            setSalesOrder(responseData.data.sales_order);
            setMeterialSo(responseData.data.meterial_so);
            setMaterialfo(responseData.data.material_fo);
            setProgressDeliveries(responseData.data.progress);

            if (responseData.data.loads) {
              const totalLoads = responseData.data.loads.total_loads || 0;
              const completedLoads = responseData.data.loads.completed_loads || 0;
              const remaining = Math.max(0, totalLoads - completedLoads);
              setRemainingLoads(remaining);
            }

            if (responseData.data.delivery) {
              const deliveryStatus = responseData.data.delivery.status;
              if (deliveryStatus === 'completed') {
                // Already completed, can stay
              } else if (deliveryStatus !== 'reached' && deliveryStatus !== 'delivered') {
                if (deliveryStatus === 'picked_up') {
                  navigate('/upload-weight-ticket');
                } else if (deliveryStatus === 'assigned') {
                  navigate('/pick-up');
                } else if (deliveryStatus === 'open') {
                  navigate('/');
                }
              }
            }
          }
        } catch (error: any) {
          console.error("Error fetching fresh data:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchFreshData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api_token, vendor_id, sales_order_id]);

  const [isweightTicket, setIsWeightTicket] = useState<boolean>(false);
  const [weightTicket, setWeightTicket] = useState<File | null>(null);
  
  const [isDumpMaterialPhoto, setIsDumpMaterialPhoto] = useState<boolean>(false);
  const [dumpMaterialPhoto, setDumpMaterialPhoto] = useState<File | null>(null);
  
  // const [isProofOfDumping, setIsProofOfDumping] = useState<boolean>(false);
    // const [proofOfDumpingPhoto, setProofOfDumpingPhoto] = useState<File | null>(null);
  
    const [isSignature, setIsSignature] = useState<boolean>(false);


  useEffect(() => {
    let weight_ticket = [];
    let dump_material_photo = [];
    // let proof_of_dumping = [];
    let signature_photo = [];

    if (photos && Array.isArray(photos)) {
      weight_ticket = photos.filter((field: any) => field.photo_type === "weight_ticket");
    }
    if (photos && Array.isArray(photos)) {
      dump_material_photo = photos.filter((field: any) => field.photo_type === "dump_material" );
    }
     if (photos && Array.isArray(photos)) {
      signature_photo = photos.filter((field: any) => field.photo_type === "signature" );
    }
    //    if (photos && Array.isArray(photos)) {
    //   proof_of_dumping = photos.filter((field: any) => field.photo_type === "proof_dumping");
    // }

    // Check if weight ticket exists and has a valid file_url
    if (weight_ticket.length !== 0 && weight_ticket[0].file_url && weight_ticket[0].file_url !== null) {
      setIsWeightTicket(true); 
    } else {
      setIsWeightTicket(false);
    }
    
    // Check if dump material photo exists and has a valid file_url
    if (
  dump_material_photo.length !== 0 &&
  (
    (dump_material_photo[0].file_url && dump_material_photo[0].file_url !== null) ||
    dump_material_photo[0]?.reason
  )
) 
    //  (dump_material_photo.length !== 0 && dump_material_photo[0].file_url && dump_material_photo[0].file_url !== null || dump_material_photo[0]?.reason)
       {
      setIsDumpMaterialPhoto(true); 
    } else {
      setIsDumpMaterialPhoto(false);
    }
    
    // Check if signature exists (signature might not have file_url, so just check if it exists)
    if (signature_photo.length !== 0) {
      setIsSignature(true); 
    } else {
      setIsSignature(false);
    }
    //   if (proof_of_dumping.length !== 0 && proof_of_dumping[0].file_url !== null) {
    //   setIsProofOfDumping(true); 
    // }
    
    
  }, [photos]);

  if (isLoading || !purchaseOrder) return <SectionLoader />;

  async function getWeightTicketFile(event: React.ChangeEvent<HTMLInputElement>){
    let uploadedWeightTicket = event.target.files?.[0];
    if (uploadedWeightTicket) {
      uploadedWeightTicket = await fixImageOrientation(uploadedWeightTicket);
    }
    setWeightTicket(uploadedWeightTicket || null);
    setIsWeightTicket(true);
  }

  async function getDumpMaterialPhoto(event: React.ChangeEvent<HTMLInputElement>){
    let uploadedDumpMaterial = event.target.files?.[0];
    if (uploadedDumpMaterial) {
      uploadedDumpMaterial = await fixImageOrientation(uploadedDumpMaterial);
    }
    setDumpMaterialPhoto(uploadedDumpMaterial || null);
    setIsDumpMaterialPhoto(true);
  }

  // function getProofOfDumping(event: React.ChangeEvent<HTMLInputElement>){
  //   let uploadedProofOfDumping = event.target.files?.[0];
  //   setProofOfDumpingPhoto(uploadedProofOfDumping || null);
  //   setIsProofOfDumping(true);
  // }

  const handleExitJob = () => {
    localStorage.clear();
    try {
      window.open('','_self')?.close();
      window.close();
    } catch (e) {
      console.log('Could not close window', e);
    }
    // Fallback: redirects to home/login if window doesn't close
    setTimeout(() => {
        window.location.href = '/';
    }, 100);
  };

  // const handleAcceptNextLoad = () => {
  //   // Clear the old delivery_id so the home page can fetch fresh data for the new delivery
  //   localStorage.removeItem('delivery_id');
  //   localStorage.setItem('page', 'index');
  //   // Use navigate instead of window.location.href to avoid full page reload
  //   // This prevents API calls from happening during page transition
  //   navigate('/', { replace: true });
  // };
const handleAcceptNextLoad = () => {
  // Clear the old delivery_id so the home page can fetch fresh data for the new delivery
  localStorage.removeItem('delivery_id');
  localStorage.removeItem('picked_up_material'); // ← add this
  localStorage.removeItem('delivery_number');    // ← also clean this up for the signature page counter
  localStorage.setItem('page', 'index');
  // Use navigate instead of window.location.href to avoid full page reload
  // This prevents API calls from happening during page transition
  navigate('/', { replace: true });
};
  const Submit = async () => {
    setButtonLoading(true);
    
    // Check if delivery is already completed
    if (delivery && delivery.status === 'completed') {
      Swal.fire({
        title: "Error",
        text: "This delivery is already completed.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      setButtonLoading(false);
      return;
    }

    // Validate required fields
    if(!isweightTicket || !isDumpMaterialPhoto || !isSignature){
      Swal.fire({
        title: "Error",
        text: "Please finish the Required Fields to complete the Delivery",
        icon: "error",
        confirmButtonText: "Ok",
      });  
      setButtonLoading(false);
      return;
    }
   
    // Use delivery from context or fallback to localStorage
    const currentDeliveryId = delivery?.id || deliveryID;
    if(!currentDeliveryId || !sales_order_id || !zoho_sales_order_id) {
      Swal.fire({
        title: "Error",
        text: "Missing required information. Please refresh the page.",
        icon: "error",
        confirmButtonText: "Ok",
      });
      setButtonLoading(false);
      return;
    }

    // Validate delivery status
    if (delivery && delivery.status && !['reached', 'delivered', 'completed'].includes(delivery.status)) {
      Swal.fire({
        title: "Error",
        text: `Cannot complete delivery. Delivery status is "${delivery.status}". Expected "reached".`,
        icon: "error",
        confirmButtonText: "Ok",
      });
      setButtonLoading(false);
      return;
    }

    const formData = new FormData();
      formData.append('delivery_id', currentDeliveryId);
      formData.append('sales_order_id', sales_order_id);
      formData.append('zoho_sales_order_id', zoho_sales_order_id);
      formData.append('vendor_id', vendor_id || "");
   
      if(weightTicket){
       // Validate file type
       const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
       if (!allowedTypes.includes(weightTicket.type)) {
         Swal.fire({
           title: "Error",
           text: "Invalid weight ticket file type. Please upload an image file.",
           icon: "error",
           confirmButtonText: "Ok",
         });
         setButtonLoading(false);
         return;
       }
       // Validate file size
       const maxSize = 10 * 1024 * 1024;
       if (weightTicket.size > maxSize) {
         Swal.fire({
           title: "Error",
           text: "Weight ticket file size too large. Please upload a file smaller than 10MB.",
           icon: "error",
           confirmButtonText: "Ok",
         });
         setButtonLoading(false);
         return;
       }
       formData.append('photo_type[]','weight_ticket');
       formData.append('file[]',weightTicket);
     } 

     if(dumpMaterialPhoto){
       // Validate file type
       const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
       if (!allowedTypes.includes(dumpMaterialPhoto.type)) {
         Swal.fire({
           title: "Error",
           text: "Invalid dump material photo file type. Please upload an image file.",
           icon: "error",
           confirmButtonText: "Ok",
         });
         setButtonLoading(false);
         return;
       }
       // Validate file size
       const maxSize = 10 * 1024 * 1024;
       if (dumpMaterialPhoto.size > maxSize) {
         Swal.fire({
           title: "Error",
           text: "Dump material photo file size too large. Please upload a file smaller than 10MB.",
           icon: "error",
           confirmButtonText: "Ok",
         });
         setButtonLoading(false);
         return;
       }
       formData.append('photo_type[]','dump_material');
       formData.append('file[]',dumpMaterialPhoto);
     }

    //  if(proofOfDumpingPhoto){
    //   formData.append('photo_type[]','proof_dumping');
    //   formData.append('file[]',proofOfDumpingPhoto);
    //  }
    
     try{
       const response = await ApiService.completeDelivery(formData);
        if (response && response.success) {
       setPhotos(response.data.photos);
       console.log('complete delivery',response.data.delivery);

       setDelivery(response.data.delivery);
       
       let updatedRemaining = 0;
       if (response.data.loads) {
         const totalLoads = response.data.loads.total_loads || 0;
         const completedLoads = response.data.loads.completed_loads || 0;
         updatedRemaining = Math.max(0, totalLoads - completedLoads);
         setRemainingLoads(updatedRemaining);
       } else {
         updatedRemaining = Math.max(0, remainingLoads - 1);
         setRemainingLoads(updatedRemaining);
       }
       
       setDeliveryCompleted(true);
       
       if (updatedRemaining === 0) {
          Swal.fire({
            title: "Delivery Completed!",
            text: "All deliveries for this job have been completed.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
             // Navigate to job completion screen
             localStorage.clear();
             navigate('/job-completed', { replace: true });
          });
          return;
       }

       const showCompletionPopup = () => {
         const buttons = [];
         
         if (updatedRemaining > 0) {
           buttons.push({
             text: "Do another load for this job",
             value: "next",
             className: "btn-accept-next-popup"
           });
         }
         
         buttons.push({
           text: "I am done with this job",
           value: "exit",
           className: "btn-exit-job-popup"
         });
         
         Swal.fire({
           title: "Delivery Completed!",
           text: response.message,
           icon: "success",
           showCancelButton: false,
           showDenyButton: updatedRemaining > 0,
           confirmButtonText: updatedRemaining > 0 ? "Do another load for this job" : "I am done with this job",
           denyButtonText: "I am done with this job",
           confirmButtonColor: updatedRemaining > 0 ? "#28a745" : "#6c757d",
           denyButtonColor: "#6c757d",
           allowOutsideClick: false,
           allowEscapeKey: false,
           customClass: {
             confirmButton: updatedRemaining > 0 ? "btn-accept-next-popup" : "btn-exit-job-popup",
             denyButton: "btn-exit-job-popup"
           }
         }).then((result) => {
           if (result.isConfirmed) {
             if (updatedRemaining > 0) {
               // Show confirmation modal before proceeding
               Swal.fire({
                 title: "Confirm Another Load",
                 text: "Only select this option if dispatch has assigned another load for this job.",
                 icon: "warning",
                 showCancelButton: true,
                 confirmButtonText: "Continue",
                 cancelButtonText: "Cancel",
                 confirmButtonColor: "#28a745",
                 cancelButtonColor: "#6c757d",
                 allowOutsideClick: false,
                 allowEscapeKey: false,
               }).then((confirmResult) => {
                 if (confirmResult.isConfirmed) {
                   // User clicked Continue - proceed to next load
                   handleAcceptNextLoad();
                 } else {
                   // User clicked Cancel - exit job
                   handleExitJob();
                 }
               });
             } else {
               handleExitJob();
             }
           } else if (result.isDenied) {
             handleExitJob();
           }
         });
       };
       
       showCompletionPopup();
        
        }else{
        Swal.fire({
          title: "Error!",
          text: response.message,
          icon: "error",
          confirmButtonText: "Ok",
        })
        }
     }catch(error){
         console.error("Upload error:", error);
         setButtonLoading(false);
        Swal.fire({
          title: "Error",
          text: "Submission failed. Try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
        
     }finally {
      setButtonLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .completion-buttons-container {
          padding: 0 10px;
          max-width: 100%;
        }
        .btn-accept-next {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          color: #fff;
          border: none;
          padding: 16px 24px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
        }
        .btn-accept-next:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
          color: #fff;
        }
        .btn-accept-next:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .btn-exit-job {
          background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
          color: #fff;
          border: none;
          padding: 16px 24px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
        }
        .btn-exit-job:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
          color: #fff;
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        }
        .btn-exit-job:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .btn-accept-next-popup {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
          color: #fff !important;
          border: none !important;
          padding: 12px 24px !important;
          border-radius: 8px !important;
          font-weight: 600 !important;
          font-size: 16px !important;
          margin-right: 10px !important;
          transition: all 0.3s ease !important;
        }
        .btn-accept-next-popup:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4) !important;
        }
        .btn-exit-job-popup {
          background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
          color: #fff !important;
          border: none !important;
          padding: 12px 24px !important;
          border-radius: 8px !important;
          font-weight: 600 !important;
          font-size: 16px !important;
          transition: all 0.3s ease !important;
        }
        .btn-exit-job-popup:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.4) !important;
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
        }
        @media (max-width: 768px) {
          .completion-buttons-container {
            padding: 0 5px;
          }
          .btn-accept-next,
          .btn-exit-job {
            padding: 14px 20px;
            font-size: 15px;
          }
          .btn-accept-next-popup,
          .btn-exit-job-popup {
            padding: 10px 20px !important;
            font-size: 15px !important;
          }
        }
      `}</style>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

        <div className="col-lg-9 col-12 content-area"> 
          <div className="row">
            <div className="col-12 mb-3">
              <BackButton />
            </div>
            <div className="col-12 mb-4">
              <div className="box py-2">
                <h4 className="mb-2 text-center fw-semibold">
                  Almost Done!
                </h4>
                <h5 className="mb-0 mt-3 text-center">
                  Please finish the following tasks to complete this delivery
                </h5>
              </div>
            </div>
            <div className="col-md-12 m-auto mt-4">
              <div className="box mb-1 py-1">
                <div className={`${!isweightTicket ? 'required' : '' } row required_row align-items-center justify-content-between`}>
                  <div className="col-8">
                    <h6 className="title_required">
                      Weight Ticket {!isweightTicket && (<span className="danger-text">*</span>)}
                    </h6>
                  </div>
                  <div className="col-4 text-end">
                    {!isweightTicket && (
                      <div className="form-group">
                        <label className="label_input" htmlFor="WeightTicket">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 66 57" fill="none" >
                            <path d="M33 0L21 12H30V36H36V12H45L33 0Z" fill="#E07B00" />
                            <path d="M54 57H12C5.37 57 0 51.63 0 45V33H6V45C6 48.31 8.69 51 12 51H54C57.31 51 60 48.31 60 45V33H66V45C66 51.63 60.63 57 54 57Z" fill="#E07B00" />
                          </svg>
                        </label>
                        <input 
                        accept="image/*"
                         onChange={getWeightTicketFile}
                         type="file" 
                         id="WeightTicket"
                          className="hiddenInput" 
                          name="weigth_ticket"
                        />
                      </div>
                    )}
                    {isweightTicket && (
                      <div className="form-group">
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 64 64"  fill="none"
                        >
                          <rect width="64" height="64" rx="8" fill="#098148" />
                          <path d="M20 34L28 42L44 22" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="box mb-1 py-1">
                <div className={`${!isDumpMaterialPhoto ? 'required' : '' } row required_row align-items-center justify-content-between`}>
                  <div className="col-8">
                    <h6 className="title_required">
                      Dump Material Photo {!isDumpMaterialPhoto && (<span className="danger-text">*</span>)}
                    </h6>
                  </div>
                  <div className="col-4 text-end">
                    {!isDumpMaterialPhoto && (
                      <div className="form-group">
                        <label className="label_input" htmlFor="DumpPhoto">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 66 57" fill="none" >
                            <path d="M33 0L21 12H30V36H36V12H45L33 0Z" fill="#E07B00" />
                            <path d="M54 57H12C5.37 57 0 51.63 0 45V33H6V45C6 48.31 8.69 51 12 51H54C57.31 51 60 48.31 60 45V33H66V45C66 51.63 60.63 57 54 57Z" fill="#E07B00"
                            />
                          </svg>
                        </label>
                        <input 
                           accept="image/*"
                         onChange={getDumpMaterialPhoto}
                        type="file" 
                        id="DumpPhoto" 
                        className="hiddenInput" 
                        name="dump_material_photo"
                        />
                      </div>
                    )}
                    {isDumpMaterialPhoto && (
                      <div className="form-group">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" fill="none"  >
                          <rect width="64" height="64" rx="8" fill="#098148" />
                          <path d="M20 34L28 42L44 22" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>
               {/* <div className="box mb-3 px-3">
                <div className={`${!isProofOfDumping ? 'required' : '' } row required_row align-items-center justify-content-between`}>
                  <div className="col-8">
                    <h6 className="title_required">
                      Proof of Dumping  {!isProofOfDumping && (<span className="danger-text">*</span>)}
                    </h6>
                  </div>
                  <div className="col-4 text-end">
                    {!isProofOfDumping && (
                      <div className="form-group">
                        <label className="label_input" htmlFor="proofOfDumping">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 66 57" fill="none" >
                            <path d="M33 0L21 12H30V36H36V12H45L33 0Z" fill="#E07B00" />
                            <path d="M54 57H12C5.37 57 0 51.63 0 45V33H6V45C6 48.31 8.69 51 12 51H54C57.31 51 60 48.31 60 45V33H66V45C66 51.63 60.63 57 54 57Z" fill="#E07B00"
                            />
                          </svg>
                        </label>
                        <input 
                         capture
                         accept=".jpg,.png,.jpeg,.webp"
                         onChange={getProofOfDumping}
                        type="file" 
                        id="proofOfDumping" 
                        className="hiddenInput" 
                        name="proof_dumping"
                        />
                      </div>
                    )}
                    {isProofOfDumping && (
                      <div className="form-group">
                        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 64 64"  fill="none"
                        >
                          <rect width="64" height="64" rx="8" fill="#098148" />
                          <path d="M20 34L28 42L44 22" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div> */}
              <div className="box mb-1 py-1">
                <div className={`${!isSignature ? 'required' : '' } row required_row align-items-center justify-content-between`}>
                  <div className="col-8">
                    <h6 className="title_required">Signature {!isSignature && (<span className="danger-text">*</span>)}</h6> 
                  </div>
                  <div className="col-4 text-end">
                     {!isSignature && (
                      <div className="form-group">
                        <label className="label_input" htmlFor="Signature">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 66 57" fill="none"
                          >
                            <path  d="M33 0L21 12H30V36H36V12H45L33 0Z"  fill="#E07B00" />
                            <path d="M54 57H12C5.37 57 0 51.63 0 45V33H6V45C6 48.31 8.69 51 12 51H54C57.31 51 60 48.31 60 45V33H66V45C66 51.63 60.63 57 54 57Z" fill="#E07B00"
                            />
                          </svg>
                        </label>
                        <input  type="button"  onClick={() => navigate('/digital-signature')}  id="Signature"  className="hiddenInput"  name="dump_photo"
                        />
                      </div>
                    )}
                    {isSignature && (
                       <div className="form-group">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64" fill="none">
                          <rect width="64" height="64" rx="8" fill="#098148" />
                          <path  d="M20 34L28 42L44 22"  stroke="white"  strokeWidth="6"  strokeLinecap="round"  strokeLinejoin="round"/>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="mt-4 d-flex row m-auto flex-wrap align-items-center justify-content-center">
            <div className="col-12">
              <button 
                disabled={buttonLoading || deliveryCompleted}
                onClick={() => Submit()} 
                className="btn-orange w-100"
              >
                {buttonLoading && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                Complete Delivery
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
export default CompleteDelivery;
